document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeInstantSearchNoResultTemplate", function (defaultTemplate, _html) {
    const pageUrl = window.location.href;
    const isSearchPage = pageUrl.includes("search");
    const aisSectionId = "#algolia-shopify-instantsearch";
    /**
     * NOTE: For Search page. Hiding all section before the Algolia Instant Search (AIS) app including the AIS app.
     * This is simply doing the opposite of what we do when search is successful.
     *
     * Successful logic found in: assets/algolia-main-template.js
     *
     */
    const mainContent = document.querySelector("#MainContent");
    const sections = mainContent?.querySelectorAll(".shopify-section");

    if (sections && isSearchPage) {
      let isAfterAIS = false;
      sections.forEach((section) => {
        const ais = section.querySelector(aisSectionId);
        if (!isAfterAIS) {
          section.classList.add("hidden--important");

          if (ais) {
            isAfterAIS = true;
          }

          return;
        }

        if (isAfterAIS) {
          section.classList.remove("hidden--important");
        }
      });
    }

    /**
     * NOTE:  On Search page, search and replace {search_query} texts in "Rich text" section blocks
     *
     * For this to work the content editors will need to add the value {search_query} in any to Rich Text sections
     */
    if (isSearchPage) {
      const richTextBlocks = mainContent.querySelectorAll(".rich-text__blocks");
      const searchQuery = new URLSearchParams(window.location.search).get("q");

      richTextBlocks.forEach((block) => {
        if (block.innerHTML.includes("{search_query}")) {
          block.innerHTML = block.innerHTML.replaceAll(/\{search_query\}/gi, searchQuery);
        }
      });
    }

    /**
     * NOTE: For other pages.
     *
     * Hide only AIS app section when there are no results by default
     *
     * If no results due to user's filter selections. Continue rendering AIS app so that users can modify
     * filters to find products.
     *
     */
    if (!isSearchPage) {
      // Check if there are any refinements (filter items)
      const urlParams = new URLSearchParams(window.location.search);
      let hasRefinements = false;

      for (const key of urlParams.keys()) {
        if (key.includes("refinementList")) {
          hasRefinements = true;
          break;
        }
      }

      if (hasRefinements) return defaultTemplate;
    }
    return defaultTemplate;
  });
});
